var render = function render(){var _vm=this,_c=_vm._self._c;return _c('observacoes',{attrs:{"parse-props":_vm.parseProps,"app-methods":_vm.appMethods,"type":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }